import { FREE_GIFT_IDS } from '@/components/blocks/FreeGiftV2/constants';
import { useFreeGiftInteraction } from '@/components/blocks/FreeGiftV2/context/FreeGiftInteractionContext';
import { useFreeGiftPromotion } from '@/components/blocks/FreeGiftV2/context/FreeGiftPromotionContext';
import { PromotionGroupCard } from '@/components/blocks/FreeGiftV2/parts/PromotionGroupCard';
import { useLocalization } from '@/data/Localization';
import { Stack, Typography } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const DrawerContentMultiPromos = () => {
	const labels = useLocalization('FreeGift');
	const labelsReward = useLocalization('FreeReward');
	const { promotionGroups, setSelectedPromotionIndex, currentPartNumber } = useFreeGiftPromotion();
	const { setShowPromotionOptions, isRewardView } = useFreeGiftInteraction();

	const handleSelectPromotion = (index: number) => {
		setSelectedPromotionIndex(index);
		setShowPromotionOptions(false);
	};

	return (
		<Stack display="flex" gap="20px" p="10px">
			<Typography
				variant="bodyBaseline"
				color="grey.500"
				id={
					isRewardView ? FREE_GIFT_IDS.promotionListIntroReward : FREE_GIFT_IDS.promotionListIntro
				}
			>
				{isRewardView
					? labelsReward.RelatedPromotionsMessage.t()
					: labels.RelatedPromotionsMessage.t()}
			</Typography>
			<Stack display="flex" gap="15px">
				<Typography
					variant="bodyBaseline"
					color="grey.500"
					fontWeight={OpenSansFontWeights.semibold}
				>
					{labels.RelatedPromotions.t()}
				</Typography>
				<Stack
					display="flex"
					gap="15px"
					id={isRewardView ? FREE_GIFT_IDS.promotionListReward : FREE_GIFT_IDS.promotionList}
				>
					{promotionGroups.map((group, index) => (
						<PromotionGroupCard
							key={index}
							group={group}
							currentPartNumber={currentPartNumber}
							onSelect={() => handleSelectPromotion(index)}
						/>
					))}
				</Stack>
			</Stack>
		</Stack>
	);
};
